import { render, staticRenderFns } from "./UserLoginCodeReset.vue?vue&type=template&id=7cf8f8bd&"
import script from "./UserLoginCodeReset.vue?vue&type=script&lang=js&"
export * from "./UserLoginCodeReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports